import type { StudyLog, Subject } from '@hoedokloop/domain';
export function subjectTotalError(
  subject: Pick<Subject, 'id' | 'totalUnits'>,
  total: number | null,
  logs: readonly StudyLog[],
): string | undefined {
  if (total !== null && (!Number.isSafeInteger(total) || total < 1))
    return '총 분량은 1 이상의 정수로 적어 주세요.';
  if (total === null && subject.totalUnits !== null)
    return '이미 설정한 총 분량은 비울 수 없어요. 실제 분량으로 고쳐 주세요.';
  if (
    total !== null &&
    logs.some((log) => log.subjectId === subject.id && !log.deletedAt && log.unitEnd > total)
  )
    return '총 분량은 이미 기록한 마지막 범위보다 작을 수 없어요.';
  return undefined;
}
